import type { DocumentCard } from './api';

/**
 * CHAT-DOCS final wave (anti-goal 8, "the old version sent after a revision"): when a new version of a document lands
 * in the LIVE chat, every earlier card of the same document - same kind, same title (the title names the property) -
 * is shown superseded at once: dimmed, badged "Superseded v<N>", and with no File it. The server already marked those
 * rows superseded; without this the screen kept offering to file v1 until the chat was reopened.
 * ⭐ A FILED card stays filed - it is history that happened, not a version that lost.
 */
export const supersedeEarlierCards = <M extends { documents?: DocumentCard[] }>(messages: M[], card: DocumentCard): M[] =>
  messages.map((m) => {
    if (!m.documents?.some((d) => replacedBy(d, card))) return m;
    return { ...m, documents: m.documents.map((d) => (replacedBy(d, card) ? { ...d, status: 'superseded' as const } : d)) };
  });

const replacedBy = (d: DocumentCard, card: DocumentCard): boolean =>
  d.id !== card.id && d.kind === card.kind && d.title === card.title && d.version < card.version
  && (d.status === 'draft' || d.status === 'needs_fixing');
